/* global moment */
import React from 'react'
import ReactDOM from 'react-dom';
import Moment from 'react-moment';

class BidHistoryTableBodyRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bidHistory: {},
      expandArrow: "fa fa-angle-right fa-lg"
    }
    this.handleCollapse = this.handleCollapse.bind(this);
  }

  handleCollapse() {
    const { expandArrow } = this.state
    const classList = event.target.className;
    if (expandArrow.indexOf("right") >= 0) {
      this.setState({ expandArrow: "fa fa-angle-down fa-lg" });
    } else {
      this.setState({ expandArrow: "fa fa-angle-right fa-lg" });
    }
  }

  render() {
    const { history } = this.props
    let price = ''
    const vehicleName = history.model_name + ", " + history.make_name + ", " + history.trim_name + ", " + history.body_type
    const startTime = history.start_time.split('.')[0].replace('T', ' ')
    const endTime = history.end_time.split('.')[0].replace('T', ' ')
    let timeOfBid = history.updated_at.split('.')[0].replace('T', ' ')
    let status = ''
    let badgeClassName = ''
    const previousBid = history.previous_bid
    let renderArrorButton = null
    let previousBidUpdatedAt = ''
    let previousBidAmount = ''

    if (history.previous_bid !== null) {
      previousBidUpdatedAt = history.previous_bid.updated_at.split('.')[0].replace('T', ' ')
      previousBidAmount = history.previous_bid.amount
    }

    if (history) {
      price = history.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }

    if (history.previous_bid) {
      if (history.amount !== history.previous_bid) {
      renderArrorButton =
        <div className="bid-history-collapse-arrow" data-toggle="collapse" data-target={`.previous-bid${history.id}`} onClick={this.handleCollapse}>
          <i className={this.state.expandArrow} />
       </div>
      }
    }

    switch (history.state) {
      case "Pending":
        badgeClassName = "label label-warning"
        break
      case "Won":
        badgeClassName = "label label-success"
        break
      case "Pending Decision":
        badgeClassName = "label label-warning"
        break
      case "Closed":
        badgeClassName = "label label-default"
        break
      case "Lost":
        badgeClassName = "label label-danger"
    }

    return (
      <tbody>
        <tr>
          <td>{renderArrorButton}</td>
          <td>
            {vehicleName}
          </td>
          <td><span className={badgeClassName}>{history.state}</span></td>
          <td>{timeOfBid}</td>
          <td>${price}</td>
          <td>{startTime}</td>
          <td>{endTime}</td>
          <td><a href={history.url}><button className="btn btn-blue-invert">Details</button></a></td>
        </tr>
        <tr className={`previous-bid${history.id} collapse`} >
          <td></td>
          <td></td>
          <td></td>
          <td>{previousBidUpdatedAt}</td>
          <td>${previousBidAmount}</td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </tbody>
    )
  }
};

export default BidHistoryTableBodyRow;
